import { BATCH_CONTENT_TYPE_ID } from '@cont/Batch/utils';
import useFetch from '@hooks/useFetch';

export const getKey = (batchUID) =>
  `v1/syllabus/playlist/home/feed?product_content_type_id=${BATCH_CONTENT_TYPE_ID}&product_uid=${batchUID}`;

const useStorePlaylistFeed = (batchUID) => {
  const key = getKey(batchUID);
  const { data: { data: storePlaylistFeed = [] } = [], ...rest } =
    useFetch(key);

  return {
    key,
    storePlaylistFeed,
    ...rest
  };
};

export default useStorePlaylistFeed;
